<template>
  <div class="orders-page">
    <div class="page-container">
      <div class="user-center">
        <user-center-sidebar active="orders" :user-info="userInfo"></user-center-sidebar>

        <section class="user-main">
          <div class="user-card">
            <div class="card-title">
              <div>
                <h2>我的订单</h2>
                <span class="extra">以下为模拟订单记录</span>
              </div>
              <span class="order-count">共 {{ orders.length }} 笔订单</span>
            </div>

            <div class="order-list">
              <div class="order-item" v-for="item in orders" :key="item.id">
                <div class="product-icon">
                  <i class="el-icon-goods"></i>
                </div>
                <div class="order-info">
                  <div class="product-name">{{ item.productName }}</div>
                  <div class="order-no">订单号：{{ item.orderNo }}</div>
                </div>
                <div class="order-amount">{{ item.amount }}</div>
                <div class="order-date">
                  <i class="el-icon-date"></i>
                  下单日期：{{ item.orderedAt }}
                </div>
                <el-tag :type="item.statusType" size="small">{{ item.status }}</el-tag>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentUser } from '@/utils/auth'
import UserCenterSidebar from '@/components/UserCenterSidebar'

export default {
  name: 'Orders',
  components: {
    UserCenterSidebar
  },
  data () {
    return {
      userInfo: {},
      orders: [
        {
          id: 1,
          orderNo: 'ORD202609160001',
          productName: '供应链数字化解决方案',
          amount: '¥12,800.00',
          orderedAt: '2026-09-16 10:28',
          status: '已完成',
          statusType: 'success'
        },
        {
          id: 2,
          orderNo: 'ORD202609120002',
          productName: '企业服务标准版',
          amount: '¥4,680.00',
          orderedAt: '2026-09-12 15:46',
          status: '处理中',
          statusType: 'warning'
        },
        {
          id: 3,
          orderNo: 'ORD202609050003',
          productName: '供应链管理系统年度服务',
          amount: '¥26,000.00',
          orderedAt: '2026-09-05 09:12',
          status: '待付款',
          statusType: 'info'
        }
      ]
    }
  },
  created () {
    this.$bus.$on('login-success', this.handleLoginSuccess)
    this.checkLogin()
  },
  methods: {
    checkLogin () {
      const user = getCurrentUser()
      if (!user) {
        this.$bus.$emit('open-login')
        return false
      }
      this.userInfo = user
      return true
    },
    handleLoginSuccess () {
      if (getCurrentUser()) this.checkLogin()
    }
  },
  beforeDestroy () {
    this.$bus.$off('login-success', this.handleLoginSuccess)
  }
}
</script>

<style lang="scss" scoped>
.orders-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 20px;
}

.page-container {
  max-width: 1200px;
  margin: 0 auto;
}

.user-center {
  display: flex;
  gap: 20px;
}

.user-main {
  flex: 1;
  min-width: 0;
}

.user-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid #f0f0f0;

  h2 {
    font-size: 16px;
    color: #333;
    margin: 0 0 4px;
  }

  .extra,
  .order-count {
    font-size: 13px;
    color: #999;
  }
}

.order-list {
  padding: 8px 24px;
}

.order-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid #f5f5f5;

  &:last-child {
    border-bottom: none;
  }
}

.product-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: linear-gradient(135deg, #e8f0ff 0%, #d8e5ff 100%);
  color: #4d78d8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i {
    font-size: 24px;
  }
}

.order-info {
  flex: 1;
  min-width: 0;
}

.product-name {
  color: #333;
  font-size: 15px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-no {
  margin-top: 6px;
  color: #999;
  font-size: 13px;
}

.order-amount {
  min-width: 96px;
  color: #f56c6c;
  font-size: 15px;
  font-weight: 600;
  text-align: right;
}

.order-date {
  min-width: 168px;
  color: #999;
  font-size: 13px;

  i {
    margin-right: 4px;
  }
}

@media screen and (max-width: 768px) {
  .user-center {
    flex-direction: column;
  }

  .card-title,
  .order-item {
    align-items: flex-start;
  }

  .card-title {
    gap: 8px;
    flex-direction: column;
  }

  .order-item {
    flex-wrap: wrap;
  }

  .order-info {
    min-width: calc(100% - 64px);
  }

  .order-amount {
    margin-left: 64px;
    text-align: left;
  }

  .order-date {
    min-width: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/orders.vue